<template>
  <div>
    <top-bar title="Meus Endereços" v-if="!component"/>
    <div>
      <loading v-if="load" :fullscrean="true"/>
      <div v-else>
        <div :class="{'container container-main': !component}" style="max-width: 600px">
          <div v-if="home">
            <a class="card text-dark mb-2" v-if="empresa.tipo_delivery !== '3'">
              <div class="d-flex align-items-center">
                <div class="text-center text-muted" style="width: 40px">
                  <icon name="retirada" class="text-primary" size="20"></icon>
                </div>
                <div class="py-4">
                  <h6 class="m-0 font-weight-bold">Retirar no local</h6>
                  <div class="small">
                    <b class="text-success">Grátis</b>
                    <span v-if="!agendamento"> / {{ empresa.media_retirada | tempo }}</span>
                  </div>
                </div>
              </div>
            </a>
            <div class="my-3 text-center">Selecione um endereço</div>
          </div>
          <div class="card card-endereco mb-3" v-for="e in dados.enderecos" :key="e.id_endereco" :class="{'border-primary': e.selecionado === '1'}">
            <button type="button" class="endereco-selecao" :aria-pressed="e.selecionado === '1'" @click="selEndereco(e)">
              <span class="endereco-icone text-muted">
                <icon name="home" size="20" v-if="e.tipo_endereco === '1'"/>
                <icon name="work" size="20" v-else-if="e.tipo_endereco === '2'"/>
                <icon name="address" size="20" v-else/>
              </span>
              <span class="endereco-texto">
                <template v-if="['1','2'].includes(e.tipo_endereco)">
                  <strong>{{e.tipo_endereco === '1' ? 'Minha Casa' : 'Meu Trabalho'}}</strong>
                  <span class="small">{{e.logradouro}}, {{e.numero}}</span>
                </template>
                <template v-else>
                  <strong>{{e.logradouro}}, {{e.numero}}</strong>
                  <span class="small">{{e.bairro}}, {{e.nome_cidade}} - {{e.sigla_estado}}</span>
                </template>
              </span>
              <indicador-selecao :selecionado="e.selecionado === '1'"/>
            </button>
            <button type="button" class="endereco-opcoes text-muted" aria-label="Opções do endereço" @click="openOptions(e)">
              <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
            </button>
          </div>
          <div v-if="!dados.enderecos.length">
            <div class="text-center p-3 mx-auto" :class="{'mt-1': !component}" style="max-width: 500px;">
              <icon name="address" class="text-primary" size="36"></icon>
              <div class="text-center mt-2">Nenhum endereço cadastrado</div>
            </div>
          </div>
          <div v-if="component">
            <hr>
            <a href="javascript:" @click="cadastrarEndereco()" class="btn btn-dark btn-block">
              <i class="fa fa-plus mr-1"></i> Novo Endereço
            </a>
          </div>
        </div>
        <div class="fixed-bottom bg-white fixed-container" v-if="!component">
          <div class="p-3">
            <button class="btn btn-dark btn-block btn-bottom" @click="cadastrarEndereco()">Novo Endereço</button>
          </div>
        </div>
      </div>
    </div>

    <endereco ref="modalEndereco" :enderecos="dados.enderecos" @atualizar="atualizar"/>

    <modal-bottom :opened="modal">
      <div class="container">
        <h6 class="text-center">O que deseja fazer?</h6>
        <hr>
        <div class="d-flex mb-3">
          <button class="btn btn-dark btn-block m-1" @click="removerEndereco()">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M205.5 44.6c-9.7 3.4-15.9 11.8-18.1 24.4-1.5 8.8-2.8 11.3-7.1 14.1-2.6 1.7-5.5 1.9-38.6 1.9-23 0-37.4.4-40.2 1.1-2.7.7-6.3 2.8-9 5.1-11.2 9.8-8.8 27.5 4.6 34.2l5.3 2.6h307.2l5.3-2.6c12.7-6.4 15.5-21.9 5.9-32.8-6.4-7.3-8.1-7.6-50.2-7.6-33.4 0-36.3-.1-38.9-1.9-4.3-2.8-5.6-5.3-7.1-14.1-2.3-12.9-8.4-21.1-18.5-24.5-6.4-2.2-94.5-2.1-100.6.1m-86 127.8c-4 1.7-9.5 7.2-11.1 11.3-.8 1.8-1.4 5.6-1.4 8.5 0 11.1 17 206.6 18.5 212.8 2.2 9.2 10.4 25.4 16.7 33 12.5 15 29.9 25.5 48.8 29.5 10.5 2.2 119.5 2.2 130 0 19.9-4.2 38.6-16 50.6-31.8 5.7-7.4 12.6-21.8 14.8-30.7 2-7.9 18.8-204.3 18.4-214.2-.3-5.6-.9-7.4-3.5-11-1.7-2.4-5-5.3-7.4-6.5l-4.2-2.3H256.1c-108.5.1-134.2.3-136.6 1.4"/></svg>
            Remover
          </button>
          <button class="btn btn-primary btn-block m-1" @click="editarEndereco(endereco)">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 512 512" fill="currentColor"><path d="M127.5 45c-41.7 8.8-74 41.4-82.5 83.2-2 9.6-2 13-1.8 131.1l.3 121.2 2.2 7.7c4.9 17.1 11.2 29.6 21.3 42.1 13.9 17.2 32.8 29.2 56.8 36l7.7 2.2 120.9.3c105.1.2 122.1 0 129.1-1.3 44.2-8.2 77.6-41.6 86-85.8 2.3-12 2.2-150 0-155.5-6.7-16-29.9-17-38.3-1.7-1.5 2.7-1.8 10.6-2.3 76-.6 81-.2 76.7-7.6 91.5-5.4 11-17 22.4-28.4 27.8-14.9 7.1-7.1 6.7-134.9 6.7-93.7 0-116.5-.3-121-1.4-18.1-4.4-35.2-18-42.8-34.1-7.1-15-6.7-7.2-6.7-135s-.4-120 6.7-135c5.4-11.4 16.8-22.9 27.8-28.4 14.9-7.3 10.5-6.9 91.7-7.5l73.1-.6 4.4-3c13.8-9.7 11.8-30.6-3.4-37-3.3-1.3-13-1.5-76.5-1.4-67.4 0-73.5.2-81.8 1.9"/><path d="M395.2 44.4c-11.6 2.9-19.7 8-33.5 21.5-7.1 6.9-13.9 14.4-15 16.6-2.8 5.4-2.8 13.6 0 19 2.7 5 59.5 61.6 64.3 64.1 4.9 2.5 13.4 2.4 18.5-.3 2.2-1.1 9.7-7.9 16.7-15.1 10.9-11.2 13.2-14.1 16.6-21.3 4.7-9.8 6.2-16.2 6.2-26.4s-1.5-16.6-6.2-26.3c-7.3-15.4-22.6-27.8-38.9-31.7-7.7-1.8-21.4-1.8-28.7-.1M298 132.2c-2.7.7-14.7 12.1-53.8 51.1-27.7 27.6-51.2 51.6-52.2 53.2-1 1.7-6.2 20.3-11.5 41.5-8 31.7-9.6 39.5-9.3 44.2.5 6.6 3.3 11.5 9.1 15.5 7.2 5 10.5 4.6 53.7-6.2 21.2-5.3 39.8-10.5 41.5-11.5 1.6-1 25.6-24.5 53.2-52.2 53.4-53.6 52.3-52.3 52.3-61.8-.1-7.7-3-11.4-32.8-41.3-30.5-30.6-34.6-33.8-42.6-33.6-2.3 0-5.7.5-7.6 1.1"/></svg>
            Editar
          </button>
        </div>
        <div>
          <button type="button" class="btn btn-block p-3 mb-1 text-dark" @click="fecharOptions()">Cancelar</button>
        </div>
      </div>
    </modal-bottom>

  </div>
</template>

<script>
  import IndicadorSelecao from "../components/IndicadorSelecao";
  import Loading from "../components/Loading";
  import Icon from "../components/Icon";
  import ModalBottom from "../components/ModalBottom";
  import TopBar from "../components/TopBar";
  import Endereco from "../components/Endereco";

  export default {
    name: 'PerfilEndereco',
    components: {IndicadorSelecao, Endereco, TopBar, ModalBottom, Icon, Loading},
    props: ['component'],

    data() {
      return {
        load: true,
        token: localStorage.getItem('token'),
        home: true,
        agendamento: false,
        url: '',
        modal: false,
        endereco: null,
        dados: { enderecos: [] }
      }
    },

    methods: {
      removerEndereco() {
        this.modal = false;

        if (this.endereco.selecionado === '1') {
          this.$swal("Não é possível remover um endereço selecionado como principal.");
          return;
        }

        this.$swal({
          text: 'Tem certeza que deseja remover este endereço?',
          buttons: ["Não", "Sim"],
          dangerMode: true,
        }).then((r) => {
          if (r) {
            this.load = true;
            this.endereco.delete = true;
            const url = this.$helpers.base_url(this, this.empresa);

            this.$http.post(url + this.token + "/endereco", this.endereco)
              .then(res => {
                this.load = false;

                if (!res.data || !res.data.success || !res.data.dados) {
                  this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
                  return;
                }

                this.dados = res.data.dados;
                this.$store.state.dataUser = this.dados;

              }, res => {
                this.load = false;
                console.log(res);
              });
          }
        });
      },

      atualizar(dados, id_selecionado) {
        if (id_selecionado) {
          this.dados.enderecos.forEach(end => {
            end.selecionado = (end.id_endereco === id_selecionado) ? '1' : ''
          });

          if (this.home) {
            this.$router.go(-1);
          }

        } else {
          this.dados = dados;
        }

        this.$emit('atualizar');
      },

      selEndereco(e) {
        if (e.selecionado !== '1') {
          this.editarEndereco(e, true, false)

        } else {
          this.$emit('fechar');
        }
      },

      cadastrarEndereco() {
        this.$refs.modalEndereco.novoEndereco()
        this.modal = false;
      },

      editarEndereco(e, selecionar, local) {
        this.$refs.modalEndereco.editarEndereco(e, selecionar, local)
        this.modal = false;
      },

      openOptions(e) {
        this.modal = true;
        this.endereco = e;
      },

      fecharOptions() {
        this.modal = false;
        this.endereco = null;
      },

      fecharComponente() {
        this.$refs.modalEndereco.closeModal();
      }
    },

    mounted() {
      this.url = this.$helpers.getUrlApp(this.$route.params.id || '');
      this.home = !!this.$route.query.home;

      if (this.token) {
        this.agendamento = this.empresa.ativo === '1' && this.empresa.aberto === '0' && this.empresa.entregas.length;
        this.dados = this.$store.state.dataUser;
        this.load = false;

        this.$nextTick(() => {
          window.scrollTo(0, 0);
        });

      } else {
        this.$router.push(this.url + '/perfil/login');
      }
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      sacola() {
        return this.$store.state.sacola
      }
    },

    created() {
      document.body.classList.remove("modal-open");
    },

    beforeRouteLeave(to, from, next) {
      if (this.$refs.modalEndereco?.modal) {
        this.$refs.modalEndereco.closeModal();

        if (!this.dados.enderecos.length) {
          next();

        } else {
          next(false);
        }

      } else {
        next()
      }
    },
  }
</script>

<style scoped>
  .container-main {
    padding-bottom: 100px;
  }

  .card-endereco {
    flex-direction: row;
    align-items: center;
    border: 1px solid #e3e6e9;
    box-shadow: none;
    padding: 16px 18px;
  }

  .endereco-selecao,
  .endereco-opcoes {
    border: 0;
    background: transparent;
    padding: 0;
    cursor: pointer;
  }

  .endereco-selecao {
    display: flex;
    align-items: center;
    flex: 1;
    min-width: 0;
    color: #343a40;
    text-align: left;
  }

  .endereco-icone {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 22px;
    margin-right: 9px;
  }

  .endereco-texto {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
    margin-right: 12px;
    overflow-wrap: anywhere;
  }

  .endereco-texto strong {
    font-size: 14px;
    line-height: 1.25;
  }

  .endereco-texto .small {
    font-size: 12px;
    line-height: 1.35;
  }

  .endereco-opcoes {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 32px;
    min-height: 32px;
    margin-left: 8px;
  }
</style>
